const publicUrl = 'https://douyin.sandgame.cn/'
export default publicUrl
